// extracted by mini-css-extract-plugin
export var endSessionModalBtn = "EndAllGameSessionsConfirmationModal-module--endSessionModalBtn--c897f";
export var endSessionModalContentContainer = "EndAllGameSessionsConfirmationModal-module--endSessionModalContentContainer--29153";